export const sharedWebSockets = {};
export const resetWebSockets = (url) => {
    if (url && sharedWebSockets.hasOwnProperty(url)) {
        delete sharedWebSockets[url];
    }
    else {
        for (let url in sharedWebSockets) {
            if (sharedWebSockets.hasOwnProperty(url)) {
                delete sharedWebSockets[url];
            }
        }
    }
};
//# sourceMappingURL=globals.js.map